import Vue from "vue";

export default {
  // Send a request to the login URL and save the returned JWT
  login(user) {
    return Vue.http.post("sessions", user).then(
      (response) => {
        localStorage.setItem("id_token", response.body.token);
        Vue.http.headers.common["X-Authorization"] = response.body.token;
        return "ok";
      },
      (responseError) => {
        return responseError.body.msg;
      }
    );
  },

  // To log out
  logout: function () {
    localStorage.removeItem("id_token");
    Vue.http.headers.common["X-Authorization"] = "";
  },
  checkAuth() {
    let userInfo = null;
    debugger;
    userInfo = document.cookie
      .split("; ")
      .find((row) => row.startsWith("production_user="));
    if (userInfo) {
      userInfo = JSON.parse(decodeURIComponent(userInfo.split("=")[1]));
      console.log("User Info:", userInfo);
      Vue.http.headers.common["uid"] = userInfo.uid;
      Vue.http.headers.common["client"] = userInfo.client;
      Vue.http.headers.common["token"] = userInfo.token;
    }

    return (
      userInfo !== null &&
      userInfo !== undefined &&
      userInfo !== "null" &&
      userInfo !== "undefined"
    );
  },
};



// WEBPACK FOOTER //
// ./src/auth.js